import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../components/Input';
import logo from '../../img/Airthings_Logo_Standard.png';
import { Mode } from '../../models/commonEnums';
import { ErrorType } from '../../models/commonModels';
import styles from './LoginView.module.scss';
import { SingleSignOnLogin } from './SingleSignOnLogin';

type PassedProps = {
    onChange: (value: string, id: string) => void;
    email: string;
    error?: ErrorType;
    validateInput: boolean;
    mode: Mode;
};

type Props = PassedProps;

export const LoginDefault = ({ onChange, email, error, validateInput, mode }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    return (
        <>
            {mode !== Mode.b2c_mobile && <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />}
            {(mode === Mode.b2b_desktop || mode === Mode.b2b_mobile) && <SingleSignOnLogin />}
            <Input
                label="User.Email"
                required
                id="email"
                type="email"
                helpText=""
                autoComplete="email"
                value={email}
                invalid={!!error || (validateInput && email.length === 0)}
                onChange={onChange}
            />
        </>
    );
};

export default LoginDefault;
